import React, { useState, useRef } from "react";
import ComponentWrapper from "../Shared/ComponentWrapper";

const HelixFaq = () => {
  const [openItems, setOpenItems] = useState(new Set([])); 
  const contentRefs = useRef({});

  const data = {
    rows: [
      {
        title: "What is Helix AI?",
        content: `Helix AI is an autonomous Ethereum AI agent that lets you perform on-chain actions through natural language. You can deploy smart contracts, swap tokens, transfer assets, check balances, and manage your portfolio — all by simply chatting with the AI.`,
      },
      {
        title: "How do I start using Helix AI?",
        content: `Visit https://ai.helix.org, connect your wallet, and start chatting. Every user gets 2,500 free Helix Tokens (HT) each day. Need more? Top up with HLX (1 HLX = 1,000 HT).`,
      },
      {
        title: "Is Helix AI safe to use?",
        content: `Helix AI is non-custodial — you connect your own wallet and retain full control of your keys and assets at all times. The AI uses session-based signing to execute actions on your behalf. However, as with all blockchain interactions, always review transaction details before confirming.`,
      },
      {
        title: "What can I do with HLX tokens?",
        content: `HLX powers Helix AI. Use it to buy Helix Tokens that meter usage (1 HLX = 1,000 HT), stake for rewards and voting power, and participate in on-chain governance.`,
      },
      {
        title: "Which blockchain does Helix AI support?",
        content: `Helix AI is built natively on Ethereum mainnet. You can swap tokens, transfer assets, deploy contracts, and check balances on Ethereum — all from a single conversation.`,
      },
      {
        title: "Which AI models can I use?",
        content: `Helix routes to 300+ tool-capable models, including OpenAI's GPT-6 Astra and GPT-6 Astra Pro. Pick any model in the chat selector — usage is metered from live provider rates.`,
      },
    ],
  };

  const toggleItem = (index) => {
    const newOpenItems = new Set(openItems);
    if (newOpenItems.has(index)) {
      newOpenItems.delete(index);
    } else {
      newOpenItems.add(index);
    }
    setOpenItems(newOpenItems);
  };

  // Function to get the actual height of content
  const getContentHeight = (index) => {
    const contentElement = contentRefs.current[index];
    return contentElement ? contentElement.scrollHeight : 0;
  };

  return (
    <ComponentWrapper styles="pt-[5rem] sm:pt-[7rem] relative pb-4 sm:pb-16">
      <div id="faq" className="w-full flex flex-col justify-center items-center">
        <h2 className="text-[40px] max-w-[320px] leading-[48px] text-center text-black font-medium">
          Frequently Asked Questions.
        </h2>
        <div className="w-full pt-12 justify-center items-center flex">
          <div className="w-full z-10 p-7 max-w-[610px] bg-white rounded-[16px] relative">
            <div className="w-full">
              {data.rows.map((item, index) => (
                <div key={index} className="border-b border-gray-200 last:border-b-0">
                  <button
                    className="w-full py-4  text-left flex justify-between items-center hover:bg-gray-50 border-none transition-all duration-200  "
                    onClick={() => toggleItem(index)}
                    tabIndex={0}
                    aria-expanded={openItems.has(index)}
                    aria-controls={`faq-content-${index}`}
                  >
                    <span 
                      className="font-medium pr-4"
                      style={{
                        color: "rgb(0, 0, 0)",
                        fontSize: "20px"
                      }}
                    >
                      {item.title}
                    </span>
                    <span 
                      className="text-[28px] font-normal ml-4 transition-transform duration-300 ease-out flex-shrink-0"
                      style={{ 
                        color: "#4B50E9",
                        transform: openItems.has(index) ? 'rotate(45deg)' : 'rotate(0deg)'
                      }}
                    >
                      +
                    </span>
                  </button>
                  
                  <div 
                    id={`faq-content-${index}`}
                    className="overflow-hidden transition-all duration-500 ease-in-out"
                    style={{
                      maxHeight: openItems.has(index) ? `${getContentHeight(index)}px` : '0px',
                      opacity: openItems.has(index) ? 1 : 0,
                    }}
                  >
                    <div 
                      ref={(el) => contentRefs.current[index] = el}
                      className="whitespace-pre-line leading-relaxed"
                      style={{
                        color: "rgb(75, 85, 99)",
                        fontSize: "16px",
                        paddingTop: "16px",
                        paddingBottom: "20px",
                        paddingLeft: "0px",
                        paddingRight: "0px"
                      }}
                    >
                      {item.content}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <img 
        src='/assets/hero/faqBg.png' 
        alt="" 
        className="w-dvw object-cover h-[400px] sm:h-[670px] absolute left-0 top-[6rem] sm:top-[5rem] z-0"
      />
    </ComponentWrapper>
  );
};

export default HelixFaq;